import { Directive, ElementRef, Renderer2, Input, OnInit, OnDestroy } from "@angular/core";
import { AbstractControl, FormGroupDirective } from "@angular/forms";
import { Subscription } from "rxjs";

@Directive({
  selector: "[hkt-formcontrolerror]",
})
export class FormControlErrorDirective implements OnInit, OnDestroy {
  @Input("hkt-formcontrolerror") formControlName: string;
  @Input("hkt-fieldname") fieldName: string;
  @Input("hkt-otherfieldname") otherFieldName: string;
  formControl: AbstractControl;
  formControlSubscription: Subscription;
  errorMessages;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.formControl = this.formGroupDirective.form.controls[this.formControlName];
    this.formControlSubscription = this.formControl.valueChanges.subscribe(value => {
      this.updateFormControlError();
    });
  }

  ngOnDestroy() {
    if (this.formControlSubscription) {
      this.formControlSubscription.unsubscribe();
      this.formControlSubscription = null;
    }
  }

  ngAfterViewInit() {
    const inputs = this.elementRef.nativeElement.getElementsByTagName("input");
    for (let control of inputs) {
      if (control.getAttribute("formControlName") == this.formControlName) {
        this.renderer.listen(control, "blur", event => this.updateFormControlError());
      }
    }
    const selects = this.elementRef.nativeElement.getElementsByTagName("select");
    for (let control of selects) {
      if (control.getAttribute("formControlName") == this.formControlName) {
        this.renderer.listen(control, "blur", event => this.updateFormControlError());
      }
    }
    const textareas = this.elementRef.nativeElement.getElementsByTagName("textarea");
    for (let control of textareas) {
      if (control.getAttribute("formControlName") == this.formControlName) {
        this.renderer.listen(control, "blur", event => this.updateFormControlError());
      }
    }

    // Create error messages
    const ptags = this.elementRef.nativeElement.getElementsByTagName("p");
    for (let ptag of ptags) {
      if ((" " + ptag.className + " ").indexOf(" error-msg ") >= 0) {
        this.errorMessages = ptag;
        break;
      }
    }

    if (!this.errorMessages) {
      this.errorMessages = this.renderer.createElement("p");
      this.renderer.addClass(this.errorMessages, "text-right");
      this.renderer.appendChild(this.elementRef.nativeElement, this.errorMessages);
    }
    this.renderer.addClass(this.errorMessages, "help-block");
    this.errorMessages.innerHTML = "";
  }

  private updateFormControlError() {
    if (!this.formControl.valid && this.formControl.touched) {
      this.renderer.addClass(this.elementRef.nativeElement, "has-error");
      let errorString: string = "";
      for (let error in this.formControl.errors) {
        if (error == "required") {
          errorString += "The " + this.fieldName + " field is required.<br />";
        } else if (error == "email") {
          errorString += "The " + this.fieldName + " format is invalid<br />";
        } else if (error == "minlength") {
          errorString +=
            "The " +
            this.fieldName +
            " must be at least " +
            this.formControl.getError(error).requiredLength +
            ".<br />";
        } else if (error == "maxlength") {
          errorString += "The " + this.fieldName + " is too long.<br />";
        } else if (error == "compareTo") {
          errorString += "The " + this.fieldName + " and " + this.otherFieldName + " must match.";
        } else if (error == "integer") {
          errorString += "The " + this.fieldName + " must be an integer.";
        } else {
          errorString += error + ": " + JSON.stringify(this.formControl.getError(error)) + "<br />";
        }
      }
      this.errorMessages.innerHTML = errorString;
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, "has-error");
      this.errorMessages.innerHTML = "";
    }
  }
}

/*
"accepted"         => "The :attribute must be accepted.",
"active_url"       => "The :attribute is not a valid URL.",
"after"            => "The :attribute must be a date after :date.",
"alpha"            => "The :attribute may only contain letters.",
"alpha_dash"       => "The :attribute may only contain letters, numbers, and dashes.",
"alpha_num"        => "The :attribute may only contain letters and numbers.",
"array"            => "The :attribute must be an array.",
"before"           => "The :attribute must be a date before :date.",
"between"          => array(
    "numeric" => "The :attribute must be between :min and :max.",
    "file"    => "The :attribute must be between :min and :max kilobytes.",
    "string"  => "The :attribute must be between :min and :max characters.",
    "array"   => "The :attribute must have between :min and :max items.",
),
"confirmed"        => "The :attribute confirmation does not match.",
"date"             => "The :attribute is not a valid date.",
"date_format"      => "The :attribute does not match the format :format.",
"different"        => "The :attribute and :other must be different.",
"digits"           => "The :attribute must be :digits digits.",
"digits_between"   => "The :attribute must be between :min and :max digits.",
"email"            => "The :attribute format is invalid.",
"exists"           => "The selected :attribute is invalid.",
"image"            => "The :attribute must be an image.",
"in"               => "The selected :attribute is invalid.",
"integer"          => "The :attribute must be an integer.",
"ip"               => "The :attribute must be a valid IP address.",
"max"              => array(
    "numeric" => "The :attribute may not be greater than :max.",
    "file"    => "The :attribute may not be greater than :max kilobytes.",
    "string"  => "The :attribute may not be greater than :max characters.",
    "array"   => "The :attribute may not have more than :max items.",
),
"mimes"            => "The :attribute must be a file of type: :values.",
"min"              => array(
    "numeric" => "The :attribute must be at least :min.",
    "file"    => "The :attribute must be at least :min kilobytes.",
    "string"  => "The :attribute must be at least :min characters.",
    "array"   => "The :attribute must have at least :min items.",
),
"not_in"           => "The selected :attribute is invalid.",
"numeric"          => "The :attribute must be a number.",
"regex"            => "The :attribute format is invalid.",
"required"         => "The :attribute field is required.",
"required_if"      => "The :attribute field is required when :other is :value.",
"required_with"    => "The :attribute field is required when :values is present.",
"required_without" => "The :attribute field is required when :values is not present.",
"same"             => "The :attribute and :other must match.",
"size"             => array(
    "numeric" => "The :attribute must be :size.",
    "file"    => "The :attribute must be :size kilobytes.",
    "string"  => "The :attribute must be :size characters.",
    "array"   => "The :attribute must contain :size items.",
),
"unique"           => "The :attribute has already been taken.",
"url"              => "The :attribute format is invalid.",
*/
